import React from 'react';
import PropTypes from 'prop-types';
import styles from './RadioBtn.module.scss';

const RadioBtn = ({checked, disabled, clickHandler, ...props}) => {

    const onClickHandler = disabled ? () => null : clickHandler;
    const classes = [styles.customRadioBtnContainer];
    if (disabled) classes.push(styles.customRadioBtnDisabled);
    if (checked) classes.push(styles.customRadioBtnChecked);

    return (
        <div className={classes.join(' ')}
             onClick={onClickHandler}>
            {checked ? <div className={styles.dotInside}/> : null}
        </div>
    );
};

RadioBtn.propTypes = {
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    clickHandler: PropTypes.func,
};

RadioBtn.defaultProps = {
    disabled: false,
    checked: false,
    clickHandler: () => null,
};

export default RadioBtn;
